<template>
  <div
    class="create-wraper"
    :class="{
      [`create-wraper--${createRenderType}`]: true,
    }"
  >
    <h1 class="h1-seo">
      Unlock Your Creativity with the Best AI Music Generator: Create Original
      Tunes Effortlessly
    </h1>
    <CreateEdit
      @click.native="
        () => {
          switchCurOpModule('createEdit', true);
        }
      "
      ref="refCreateEdit"
    ></CreateEdit>
    <div
      class="create-result flex1"
      v-if="createRenderType != 'mobile'"
      @click.native="
        () => {
          switchCurOpModule('createResult', false);
        }
      "
    >
      <GenerateResult @restore="doRestore"></GenerateResult>
    </div>
    <div v-if="userDataStore.appLanguage=='en'" v-html="seoHtml" class="seo-html"></div>


  
  </div>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { storeToRefs } from "pinia";
import CreateEdit from "@/page/create/createEdit.vue";
import GenerateResult from "./feedList/generateResult.vue";
import { seoHtml, seoHeader } from "./seo/seo.js";
import { renderAlternate } from "@/utils/tools.js";

import useDraftDataStore from "@/store/create/draftDataStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useDiverStore from "@/store/driverStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import usePresetSourceDataStore from "@/store/create/presetSourceDataStore.js";
import useDialogStore from "@/store/dialogStore.js";
import { useRouter, useRoute } from "vue-router";
import { useSeoMeta, useHead } from "@unhead/vue";
import config from "@/config/config";
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const Router = useRouter();
const route = useRoute();
useHead({
  link: [{ rel: "canonical", href: config.baseOrigin + "/" + (route.params?.lang ? `${route.params?.lang}/` : "" ) }, ...renderAlternate('/')],
  script: [
    {
      innerHTML: seoHeader,
      type: "application/ld+json",
      tagPosition: "head",
    },
  ],
});

const draftDataStore = useDraftDataStore();
const driverStore = useDiverStore();
const createLayoutStore = useCreateLayoutStore();
const presetSourceDataStore = usePresetSourceDataStore();
const dialogStore = useDialogStore();
const feedListDataStore = useFeedListStore();
const userDataStore = useUserDataStore();

const { curDriverKey } = storeToRefs(driverStore);
const {
  createEditMode,
  createRenderType,
  create_createEditOpenState,
  nocreate_createEditOpenState,
} = storeToRefs(createLayoutStore);

useSeoMeta({
  title:
    "Mureka: AI Music Generator to Create Unique Melodies, Songs, And Lyrics with Artificial Intelligence | Best AI Composers, Music Creation Tools & Platforms",
  description:
    "Mureka.ai: Create original music effortlessly with our advanced AI music generator. Compose, customize, and download unique tracks in minutes.",
  ogTitle: "Mureka.ai - AI Music Generator for Original Tracks",
  ogDescription:
    "Discover Mureka.ai, the ultimate AI music generator. Create, customize, and download unique music tracks effortlessly with cutting-edge AI technology.",
  ogType: "website",
  ogUrl: "https://mureka.ai/",
  ogImage: "https://mureka.ai/favicon.png",
  ogImageAlt: "Mureka.ai AI Music Generator Interface",
  ogSiteName: "Mureka.ai",
  twitterCard: "summary_large_image",
  twitterTitle: "Mureka.ai - AI Music Generator for Original Tracks",
  twitterDescription: `Create unique music with Mureka.ai's AI music generator. Compose and customize tracks in minutes with advanced AI technology.`,
  twitterImage: "https://mureka.ai/favicon.png",
  twitterImageAlt: "Mureka.ai AI Music Generator Interface",
  twitterSite: "@MurekaAI",
});

const props = defineProps({});
const emits = defineEmits([]);

const refCreateEdit = ref(null);
const renderData = reactive({});

const switchCurOpModule = (key, isOpen) => {
  createLayoutStore.setCurOpModule(key, isOpen);
};

const doRestore = () => {
  refCreateEdit.value?.openEdit();
};

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      presetSourceDataStore.getPresetSourceData(true);
    });
  }
);

onMounted(async () => {
  //  const globalProperties = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext.config.globalProperties;
  // globalProperties?.logViewEvent("create");
  // if (userDataStore.isLogin) {
  //   userDataStore.refreshUserAccount()
  // }
  presetSourceDataStore.getPresetSourceData();
  if (
    !dialogStore.isLoading &&
    !dialogStore.inviteFinishedDialog &&
    !dialogStore.recallMailDialog &&
    !dialogStore.vocalDialog &&
    !dialogStore.advGuideDialog &&
    !dialogStore.whatsNewDialog
  ) {
    dialogStore.getPopupShow();
  }
});

onUnmounted(() => {});
</script>
<style lang="scss">
.create-wraper {
  margin: 0 0 0 20px;
  height: 100%;
  display: flex;
  .h1-seo {
    font-size: 0;
    height: 0;
  }
  .create-result {
    height: 100%;
  }
  &.create-wraper--mobile {
    margin: 0;
    display: block;
  }
}
.main-page {
  &.main-page--create,
  &.main-page--createIndex,
  &.main-page--editor {
    .wrapper.show-player-create {
      .wrapper-player-create {
        display: none;
      }
      .wrapper-create {
        display: block;
        height: 80px;
      }
    }
  }
}
</style>
